import { render, staticRenderFns } from "./addCombGoods.vue?vue&type=template&id=446cf541&scoped=true&"
import script from "./addCombGoods.vue?vue&type=script&lang=js&"
export * from "./addCombGoods.vue?vue&type=script&lang=js&"
import style0 from "./addCombGoods.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addCombGoods.vue?vue&type=style&index=1&id=446cf541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446cf541",
  null
  
)

component.options.__file = "addCombGoods.vue"
export default component.exports